import { useState } from "react";
import { subscribers } from "@/lib/api";
import { Mail, CheckCircle2, ArrowRight } from "lucide-react";

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const params = new URLSearchParams(window.location.search);
      const source = params.get("utm_source") || (document.referrer ? "referral" : "footer");
      await subscribers.create({ email, source });
      setDone(true);
    } catch {
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="newsletter-signup" className="bg-zinc-900 text-white p-6">
      <div className="flex items-center gap-2 mb-2">
        <Mail className="w-4 h-4 text-[#10B981]" />
        <h4 className="text-xs uppercase tracking-[0.2em] font-bold">Boletín gratis</h4>
      </div>
      {done ? (
        <div data-testid="newsletter-success" className="flex items-center gap-2 text-sm text-[#10B981] mt-3">
          <CheckCircle2 className="w-5 h-5" />
          <span>¡Listo! Revisa tu correo para novedades y descuentos.</span>
        </div>
      ) : (
        <>
          <p className="text-sm text-zinc-400 mb-4">
            Consejos, cupones y lanzamientos de cursos directo a tu bandeja.
          </p>
          <form onSubmit={submit} className="flex gap-2">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              data-testid="newsletter-input"
              className="flex-1 bg-zinc-800 border border-zinc-700 px-4 py-2.5 text-sm outline-none focus:border-[#4F46E5]"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-btn"
              className="bg-[#4F46E5] hover:bg-[#4338CA] px-4 py-2.5 font-semibold text-sm transition-colors disabled:opacity-50 flex items-center gap-1"
            >
              {loading ? "..." : <ArrowRight className="w-4 h-4" />}
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default NewsletterSignup;
